'use strict';

/**
 * <pippei-reviewswipe> (sections/pippei-reviews.liquid, design D): arrows for the swipe track of the review cards. The track is a plain scroll-snap
 * row, so touch, trackpad, the mouse wheel and the keyboard (it can take focus) scroll it as they are; the arrows move one card.
 * They are hidden when everything fits and a little dimmed at the ends.
 */
(function () {
  if (customElements.get('pippei-reviewswipe')) return;

  class PippeiReviewSwipe extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.track = this.querySelector('[data-rv-track]');
      this.prev = this.querySelector('[data-rv-prev]');
      this.next = this.querySelector('[data-rv-next]');
      if (!this.track) return;
      if (this.prev) this.prev.addEventListener('click', function () { self._go(-1); });
      if (this.next) this.next.addEventListener('click', function () { self._go(1); });
      this.track.addEventListener('scroll', function () { self._ui(); }, { passive: true });
      window.addEventListener('resize', function () { self._ui(); });
      this._ui();
    }

    _go(dir) {
      var item = this.track.querySelector('.rv-d__item');
      var step = item ? item.getBoundingClientRect().width + 16 : this.track.clientWidth;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
    }

    _ui() {
      var t = this.track;
      var max = t.scrollWidth - t.clientWidth;
      var overflow = max > 2;
      if (this.prev) { this.prev.hidden = !overflow; this.prev.setAttribute('aria-disabled', t.scrollLeft <= 2 ? 'true' : 'false'); }
      if (this.next) { this.next.hidden = !overflow; this.next.setAttribute('aria-disabled', t.scrollLeft >= max - 2 ? 'true' : 'false'); }
    }
  }

  customElements.define('pippei-reviewswipe', PippeiReviewSwipe);
})();
